var React = require('react');

function IconContents (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M86.8 384.3c-9 0-16.3-7.3-16.3-16.3V207.5c0-9 7.3-16.3 16.3-16.3h302.4c9 0 16.3 7.3 16.3 16.3v36.8h519c9 0 16.3 7.3 16.3 16.3v107.3c0 9-7.3 16.3-16.3 16.3h-45V326c0-13.5-11-24.5-24.5-24.5H156.3c-13.5 0-24.5 11-24.5 24.5v58.3h-45zm-21.7 32.4c-.2-2 1.2-3.8 3.2-4h887.4c2.2 0 3.8 1.9 3.6 4l-44.2 409.8c-.2 2.2-2.2 4-4.5 4h-801c-2.2 0-4.2-1.9-4.4-4L65.1 416.7z"}));
}

IconContents.displayName = "IconContents";

IconContents.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconContents;

IconContents.default = IconContents;
